import { cache } from 'react'
import { apiPath } from '../_utils/api-version'
import { ITag } from '../_types'
import { request } from './http-client'

export const getTags = cache(
  async (
    params: Record<string, string | number>,
    useDynamicLanguage = false
  ) => {
    try {
      const response = await request.get<{ tags: ITag[]; count: string }>(
        apiPath('tags', useDynamicLanguage),
        { params }
      )
      return response
    } catch (error) {
      console.error('Error:', error)
      return null
    }
  }
)
